import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  rank?: number;
}

export default function ComicCard({ comic, rank }: ComicCardProps) {
  return (
    <article className="group relative flex flex-col overflow-hidden rounded-xl border border-background-800 bg-background-900/60 transition-all duration-300 hover:-translate-y-1.5 hover:border-primary-500/40 hover:bg-background-900">
      <div className="relative w-full overflow-hidden" style={{ aspectRatio: '10 / 14' }}>
        <img
          src={comic.image}
          alt={`${comic.title} 漫画封面，${comic.genre}题材`}
          title={`${comic.title} - 香蕉漫画社编辑推荐`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        {rank && (
          <span className="absolute left-3 top-3 z-10 inline-flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-sm font-bold text-foreground-950 shadow-lg">
            {rank}
          </span>
        )}
        {comic.badge && (
          <span className="absolute right-3 top-3 z-10 inline-flex items-center gap-1 rounded-md bg-accent-500 px-2 py-1 text-xs font-bold text-foreground-950">
            <i className="ri-star-fill text-[11px]" />
            {comic.badge}
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-background-950/80 to-transparent" />
      </div>
      <div className="flex flex-1 flex-col gap-2 p-4">
        <div className="flex items-center justify-between gap-2">
          <h3 className="truncate font-heading text-base font-bold text-foreground-50">{comic.title}</h3>
          <span className="inline-flex shrink-0 items-center gap-1 rounded-md bg-secondary-500/15 px-2 py-0.5 text-xs font-medium text-secondary-300">
            <i className="ri-focus-3-line text-[11px]" />
            {comic.genre}
          </span>
        </div>
        <p className="line-clamp-2 text-xs leading-relaxed text-foreground-400">{comic.tagline}</p>
        <div className="mt-auto flex items-center justify-between pt-2 text-xs text-foreground-400">
          <span className="inline-flex items-center gap-1">
            <i className="ri-heart-3-fill text-primary-400" />
            {(comic.followers / 1000).toFixed(1)}万追更
          </span>
          <span className="inline-flex items-center gap-1">
            <i className="ri-book-open-line text-secondary-400" />
            {comic.chapters}话
          </span>
          <span
            className={`inline-flex items-center gap-1 font-medium ${
              comic.status === '连载中' ? 'text-secondary-300' : 'text-foreground-500'
            }`}
          >
            <i className={`${comic.status === '连载中' ? 'ri-record-circle-line' : 'ri-checkbox-circle-line'} text-[11px]`} />
            {comic.status}
          </span>
        </div>
      </div>
    </article>
  );
}